import HistoryIcon from '@material-ui/icons/History';
import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

const rootRouteRef = createRouteRef();

const auditCenterPage = PageBlueprint.make({
  params: {
    path: '/administracao/auditoria',
    routeRef: rootRouteRef,
    loader: () =>
      import('./AuditCenterPage').then(module => <module.AuditCenterPage />),
  },
});

export const auditCenterPlugin = createFrontendPlugin({
  pluginId: 'audit-center',
  title: 'Central de Auditoria',
  icon: <HistoryIcon />,
  routes: { root: rootRouteRef },
  extensions: [auditCenterPage],
});
